import { Outlet } from 'react-router-dom';

export type TechnicalSupportModuleProps = {};

const TechnicalSupportModule: React.FC<TechnicalSupportModuleProps> = () => {
  return (
    <Outlet />
  );
};

export default TechnicalSupportModule;
